import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { isPayLaterSupported } from './klarnaOnSiteMessaging';

const KLARNA_ACCOUNT = 'klarna_account';
const KLARNA_PAY_LATER = 'klarna_pay_later';

const KLARNA_PAYMENT_METHODS = new Set([
  KLARNA_ACCOUNT,
  KLARNA_PAY_LATER,
]);

export function isKlarnaPayLaterAvailable(acceptedPaymentMethods: string[], user: Partial<IUser>) {
  if (!acceptedPaymentMethods) {
    return false;
  }

  return acceptedPaymentMethods.includes(KLARNA_PAY_LATER) &&
    isExperimentEnabled(user, experiments.KLARNA_PAY_LATER);
}

export function canTrackKlarnaPayLaterExperiment(acceptedPaymentMethods: string[], user: Partial<IUser>) {
  if (!acceptedPaymentMethods) { return false; }

  return acceptedPaymentMethods.includes(KLARNA_PAY_LATER) &&
    isPayLaterSupported(user.countryCode);
}

export function filterBuyerPaymentMethods(acceptedPaymentMethods: string[], user: Partial<IUser>) {
  if (!acceptedPaymentMethods) {
    return [];
  }

  function isPaymentMethodAvailable(paymentMethod: string) {
    if (paymentMethod === KLARNA_PAY_LATER && !isExperimentEnabled(user, experiments.KLARNA_PAY_LATER)) {
      return false;
    }

    return true;
  }

  return acceptedPaymentMethods.filter(isPaymentMethodAvailable);
}

export function hasPaymentMethodViaKlarna(acceptedPaymentMethods: string[]) {
  if (!acceptedPaymentMethods) {
    return false;
  }

  return acceptedPaymentMethods.some((paymentMethod) => KLARNA_PAYMENT_METHODS.has(paymentMethod));
}
